import React, { useEffect, useState } from 'react';
import { getCachedSuperDebt } from '../../../../../lib/api/integrations/debt';
import { useDispatch, useSelector } from 'react-redux';
import EnhancedTable from '../../../../../lib/designSystem/Table';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import HeaderWithActions from '../../../../../lib/designSystem/HeaderWithActions';
import { getConsultorResponse } from '../../../../../lib/api';
import {
  formatDate,
  showAlert,
  validatePermissions,
} from '../../../../../lib/functions/utils';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import CustomButton from '../../../../../lib/designSystem/Button';
import { Update } from '@mui/icons-material';
import { AuthState } from '../../../../../services/redux/authSlice';
import { useParams } from 'react-router-dom';

const SuperDebt = (props: any) => {
  const { businessId } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [lastUpdate, setLastUpdate] = useState<any>(null);
  const [superDebt, setSuperDebt] = useState<any>({
    identifier: businessId,
    headers: [],
    rows: [],
  });
  const { id } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const businessIdentifier = id || businessId;
  const fetchCachedSuperDebt = async () => {
    setLoading(true);
    try {
      const superDebt = await getCachedSuperDebt(dispatch, businessIdentifier);
      setSuperDebt(superDebt.data);
      setLastUpdate(superDebt.lastUpdate);
    } catch (error) {
      console.log(error);
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
    }
    setLoading(false);
  };

  const fetchSuperDebt = async () => {
    setLoading(true);
    try {
      const responseConsult = await getConsultorResponse(dispatch, {
        type: 'rut',
        consult: 'superDebt',
        payload: {
          identifier: businessIdentifier,
        },
      });
      setSuperDebt(responseConsult);
      setLastUpdate(new Date());
      setOpen(false);
    } catch (error) {
      console.log(error);
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
    }
    setLoading(false);
  };

  const canUpdate = () => validatePermissions(user, 'can_update_debt');

  useEffect(() => {
    fetchCachedSuperDebt();
  }, []);

  if (loading) {
    return <CenteredCircularProgress relative />;
  }

  return (
    <div>
      <HeaderWithActions
        item={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography>
              {lastUpdate
                ? `Última actualización: ${formatDate(lastUpdate)}`
                : 'No se ha actualizado la deuda'}
            </Typography>
            <IconButton
              disabled={!canUpdate()}
              onClick={() => setOpen(true)}
              sx={{ marginLeft: 1 }}
            >
              <Update />
            </IconButton>
          </div>
        }
        title="Deuda de la empresa."
        variant="body1"
      />
      {superDebt.rows.length > 0 && (
        <div
          style={
            businessId
              ? { maxHeight: '400px', overflow: 'auto' }
              : { paddingBottom: '20px' }
          }
        >
          <EnhancedTable
            exportToFile="xlsx"
            dataHeaders={superDebt.headers}
            data={superDebt.rows}
            rowsPerPageDefault={20}
          />
        </div>
      )}
      {superDebt.rows.length === 0 && (
        <Typography fontWeight="bold">
          No se encontraron resultados, actualiza la deuda.
        </Typography>
      )}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Actualizar deuda</DialogTitle>
        <DialogContent>
          <Typography>
            Recuerda que esta acción consume créditos de tu plan.
          </Typography>
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setOpen(false)}>
            Cancelar
          </CustomButton>
          <CustomButton onClick={() => fetchSuperDebt()}>
            Actualizar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SuperDebt;
